export const isPwa = (): boolean =>
  window.matchMedia('(display-mode: standalone)').matches ||
  (window.navigator as unknown as { standalone?: boolean }).standalone === true;

export const isIos = (): boolean => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const isInBrowserOnIos = (): boolean => isIos() && !isPwa();
